import { render, staticRenderFns } from "./InputBodyMeasurement.vue?vue&type=template&id=087e2efb"
import script from "./InputBodyMeasurement.vue?vue&type=script&lang=js"
export * from "./InputBodyMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports